import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { FuseSharedModule } from '@fuse/shared.module';

import { ForgotPasswordConfirmationComponent } from 'app/authentication/forgot-password-confirmation/forgot-password-confirmation.component';
import { AnonymousGuard } from 'app/_guards/anonymous.guard';

const routes = [
    {
        path: 'auth/forgot-password-confirmation',
        component: ForgotPasswordConfirmationComponent,
        canActivate: [AnonymousGuard]
    }
];

@NgModule({
    declarations: [ForgotPasswordConfirmationComponent],
    imports: [
        RouterModule.forChild(routes),

        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,

        FuseSharedModule
    ]
})
export class ForgotPasswordConfirmationModule {}
